import React from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const CheckoutOrderInfo = () => {
    const cart = useSelector((state) => state.cart);

    return (
        <div className="columns small-12 medium-6 checkout-info__summary--full-row checkout-info__total">
            <div className="checkout-info__summary--part-sum checkout-info__summary--part-sum-border">
                {translate('checkout.order.productstotal')}{' '}
                <span className="checkout-info__summary--expand"></span>{' '}
                <span className="checkout-info__summary--part-sum-price">{cart.orderTotal}</span>
            </div>
            <div className="checkout-info__summary--part-sum checkout-info__summary--part-sum-border">
                {translate('checkout.order.deliverycost')}{' '}
                <span className="checkout-info__summary--expand"></span>{' '}
                <span className="checkout-info__summary--part-sum-price">{Math.round(parseFloat(cart.deliveryCost))} kr</span>
            </div>
            <h3 className="checkout-info__summary--part-sum">
                {translate('code.checkout.order.grandtotalexclvat')}{' '}
                <span className="checkout-info__summary--expand"></span>{' '}
                {cart.grandTotal}
            </h3>
        </div>
    );
};

export default CheckoutOrderInfo;
